import { LogLevel } from 'amazon-chime-sdk-js';
export class ChimeLogger {
    constructor(logger, isVideoProviderVerboseLoggingEnabled = false) {
        this.logLevel = undefined;
        this.streemLogger = logger.extend('chime-sdk-js');
        // this chime-sdk logger is very chatty and overwhelms the scribe service, so disable
        //     debug and info logging by default.
        this.extendedChimeLogging =
            process.env.REACT_APP_ENABLE_CHIME_EXTENDED_LOGGING === 'true' ||
                isVideoProviderVerboseLoggingEnabled;
        if (this.extendedChimeLogging) {
            this.streemLogger.info('Enabled Chime verbose logging`');
        }
    }
    debug(debugFunction) {
        if (this.extendedChimeLogging) {
            const msg = typeof debugFunction === 'string' ? debugFunction : debugFunction();
            this.streemLogger.debug(msg, { chimeSdkLogLevel: 'debug' });
        }
    }
    info(msg) {
        if (this.extendedChimeLogging) {
            this.streemLogger.info(msg, { chimeSdkLogLevel: 'info' });
        }
    }
    warn(msg) {
        // log as info, but indicate that the chime-sdk considers it a warning
        this.streemLogger.info(msg, { chimeSdkLogLevel: 'warn' });
    }
    error(msg) {
        // log as info, but indicate that the chime-sdk considers it an error
        this.streemLogger.info(msg, { chimeSdkLogLevel: 'error' });
    }
    setLogLevel(_) {
        // this will default to whatever the level is that is set in the StreemLogger.  There
        //    is no way to change the level of the StreemLogger after it is created.
        return;
    }
    getLogLevel() {
        // the log level cannot change, so calculate it once (lazily)
        if (this.logLevel !== undefined) {
            return this.logLevel;
        }
        if (this.streemLogger.isTrace()) {
            this.logLevel = LogLevel.DEBUG; // there is no trace level in Chime
        }
        else if (this.streemLogger.isDebug()) {
            // see debug() implementation above for debug messages may not be logged
            //     even if the log level is DEBUG or TRACE
            this.logLevel = LogLevel.DEBUG;
        }
        else if (this.streemLogger.isInfo()) {
            return LogLevel.INFO;
        }
        else if (this.streemLogger.isWarn()) {
            this.logLevel = LogLevel.WARN;
        }
        else if (this.streemLogger.isError()) {
            this.logLevel = LogLevel.ERROR;
        }
        else {
            this.logLevel = LogLevel.OFF;
        }
        return this.logLevel;
    }
}
//# sourceMappingURL=chime_logger.js.map